import { TranslationsContext } from '@teliaee/telia-translate';
import { media, Table } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import React from 'react';
import MediaQuery from 'react-responsive';
import RoamingStore from '../../stores/RoamingStore';
import { PwsNumber } from '../RoamingInterfaces';
import {
  renderSpecialInformationDesktopTableHeading,
  renderSpecialInformationDesktopTableRow,
  renderSpecialInformationMobileTableRow
} from './RoamingSpecialAndEmergencyTableUtil';

interface DangerNoticesProps {
  roamingStore?: RoamingStore;
}

const DangerNotices = (props: DangerNoticesProps): JSX.Element => {
  const {
    roamingStore: {
      roamingBerecInformation: { berecInformation }
    }
  } = props;
  const { translate } = React.useContext(TranslationsContext);

  const tableHeadingMeansOfAccess = translate('roaming.berec.means-of-access');
  const tableHeadingType = translate('roaming.berec.type');
  const tableHeadingDescription = translate('roaming.berec.description-reference');
  const tableHeadingDownload = translate('roaming.berec.download-reference');
  const tableHeadingAdditionalInfo = translate('roaming.berec.additional-info');

  const getTableRowValues = (info: PwsNumber): { [key: string]: string } => ({
    [tableHeadingMeansOfAccess]: info.pwsMeansOfAccess,
    [tableHeadingType]: info.typeOfPws,
    [tableHeadingDescription]: info.linkToPwsDescription,
    [tableHeadingDownload]: info.linkToPwsDownload,
    [tableHeadingAdditionalInfo]: info.additionalInformation
  });

  const renderDangerNoticesDesktop = (): JSX.Element => (
    <Table>
      <thead>
        {renderSpecialInformationDesktopTableHeading(
          'danger-notice',
          [tableHeadingMeansOfAccess, tableHeadingType, tableHeadingDescription, tableHeadingDownload, tableHeadingAdditionalInfo],
          [2, 2, 3, 3, 2]
        )}
      </thead>
      <tbody>
        {berecInformation.pwsNumbers.map((info, index) =>
          renderSpecialInformationDesktopTableRow(`danger-notice-${index}`, getTableRowValues(info), [2, 2, 3, 3, 2])
        )}
      </tbody>
    </Table>
  );

  const renderDangerNoticesMobile = (): JSX.Element => (
    <Table>
      {berecInformation.pwsNumbers.map((info, index) => renderSpecialInformationMobileTableRow(`danger-notice-${index}`, index, getTableRowValues(info)))}
    </Table>
  );

  return <MediaQuery minWidth={media.width.md.min}>{(matches) => (matches ? renderDangerNoticesDesktop() : renderDangerNoticesMobile())}</MediaQuery>;
};

export default inject('roamingStore')(observer(DangerNotices));
